import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import WithRouter, { type RouterProps } from "@/components/common/WithRouter"
import useMenuItems from "@/hooks/useMenuItems"
import SimpleBar from "simplebar-react"
import VerticalLayout from "../VerticalLayouts"

const logoMenuSm = import.meta.env.VITE_LOGO_MENU_SM ?? ""

interface TwoColumnLayoutProps {
  layoutType: string
  router?: RouterProps
}
const TwoColumnLayout: React.FC<TwoColumnLayoutProps> = (props) => {
  const navData = useMenuItems()

  // Scroll arriba al cambiar de ruta. La activación de menús la maneja React
  // (state compartido en useMenuItems via store externo). Eliminamos initMenu
  // y removeActivation legacy que mutaban el DOM directamente compitiendo con
  // React y causaban toggle intermitente.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [props.router?.location.pathname])

  // Resize sidebar
  const [isMenu, setIsMenu] = useState("twocolumn")
  useEffect(() => {
    if (props.layoutType !== "twocolumn") return
    const handler = () => {
      const windowSize = document.documentElement.clientWidth
      if (windowSize < 767) {
        document.documentElement.setAttribute("data-layout", "vertical")
        setIsMenu("vertical")
      } else {
        document.documentElement.setAttribute("data-layout", "twocolumn")
        setIsMenu("twocolumn")
      }
    }
    handler()
    window.addEventListener("resize", handler)
    return () => window.removeEventListener("resize", handler)
  }, [props.layoutType])

  return (
    <React.Fragment>
      {isMenu === "twocolumn" ? (
        <div id="scrollbar">
          <div className="container-fluid">
            <div id="two-column-menu">
              <SimpleBar className="twocolumn-iconview">
                <Link to="/" className="logo">
                  <img src={logoMenuSm} alt="Logo" height="22" style={{ objectFit: "contain" }} />
                </Link>
                {(navData || []).map((item, key) => (
                  <React.Fragment key={key}>
                    {item.icon &&
                      (item.subItems ? (
                        <li>
                          <Link
                            onClick={item.click}
                            to="#"
                            className="nav-icon"
                            role="button"
                            aria-expanded={item.stateVariables}
                          >
                            <i className={item.icon}></i>
                          </Link>
                        </li>
                      ) : (
                        <>
                          <Link
                            onClick={item.click}
                            to={item.link ? item.link : "/#"}
                            className="nav-icon"
                            role="button"
                          >
                            <i className={item.icon}></i>
                          </Link>
                        </>
                      ))}
                  </React.Fragment>
                ))}
              </SimpleBar>
            </div>
            <SimpleBar id="navbar-nav" className="navbar-nav">
              {(navData || []).map((item, key) => (
                <React.Fragment key={key}>
                  {item.subItems ? (
                    <li className="nav-item">
                      <div
                        className={`menu-dropdown collapse${item.stateVariables ? " show" : ""}`}
                        id={item.id}
                      >
                        <ul className="nav nav-sm flex-column test">
                          {/* subItms  */}
                          {item.subItems &&
                            (item.subItems || []).map((subItem, key) => (
                              <React.Fragment key={key}>
                                {!subItem.isChildItem ? (
                                  <li className="nav-item">
                                    <Link
                                      to={subItem.link ? subItem.link : "/#"}
                                      className="nav-link"
                                    >
                                      <i className={subItem.icon || "ri-question-line"}></i> <span>{subItem.label}</span>
                                      {subItem.badge?.name ? (
                                        <span
                                          className={
                                            "badge badge-pill bg-" +
                                            subItem.badge?.color
                                          }
                                          data-key="t-new"
                                        >
                                          {subItem.badge?.name}
                                        </span>
                                      ) : null}
                                    </Link>
                                  </li>
                                ) : (
                                  <li className="nav-item">
                                    <Link
                                      onClick={subItem.click}
                                      className="nav-link"
                                      to="/#"
                                      role="button"
                                      aria-expanded={subItem.stateVariables}
                                    >
                                      <i className={subItem.icon || "ri-question-line"}></i> <span>{subItem.label}</span>
                                      {subItem.badge?.name ? (
                                        <span
                                          className={
                                            "badge badge-pill bg-" +
                                            subItem.badge?.color
                                          }
                                          data-key="t-new"
                                        >
                                          {subItem.badge?.name}
                                        </span>
                                      ) : null}
                                    </Link>
                                    <div
                                      className={`menu-dropdown collapse${subItem.stateVariables ? " show" : ""}`}
                                      id={`tc-sub-${item.id}`}
                                    >
                                      <ul className="nav nav-sm flex-column">
                                        {/* child subItms  */}
                                        {subItem.subItems &&
                                          (subItem.subItems || []).map(
                                            (childItem, key) => (
                                              <li
                                                className="nav-item"
                                                key={key}
                                              >
                                                <Link
                                                  to={
                                                    childItem.link
                                                      ? childItem.link
                                                      : "/#"
                                                  }
                                                  onClick={childItem.click}
                                                  className="nav-link"
                                                >
                                                  {childItem.label}
                                                </Link>
                                                <div
                                                  className={`menu-dropdown collapse${childItem.stateVariables ? " show" : ""}`}
                                                  id={`tc-child-${item.id}`}
                                                >
                                                  <ul className="nav nav-sm flex-column">
                                                    {/* child subChildItems  */}
                                                    {childItem.isChildItem &&
                                                      (
                                                        childItem.subItems ||
                                                        []
                                                      ).map(
                                                        (childItem, key) => (
                                                          <li
                                                            className="nav-item"
                                                            key={key}
                                                          >
                                                            <Link
                                                              to={
                                                                childItem.link
                                                                  ? childItem.link
                                                                  : "/#"
                                                              }
                                                              className="nav-link"
                                                            >
                                                              {childItem.label}
                                                            </Link>
                                                          </li>
                                                        )
                                                      )}
                                                  </ul>
                                                </div>
                                              </li>
                                            )
                                          )}
                                      </ul>
                                    </div>
                                  </li>
                                )}
                              </React.Fragment>
                            ))}
                        </ul>
                      </div>
                    </li>
                  ) : null}
                </React.Fragment>
              ))}
            </SimpleBar>
          </div>
        </div>
      ) : (
        <SimpleBar id="scrollbar" className="h-100">
          <div className="container-fluid">
            <div id="two-column-menu"></div>
            <ul className="navbar-nav" id="navbar-nav">
              <VerticalLayout />
            </ul>
          </div>
        </SimpleBar>
      )}
    </React.Fragment>
  )
}

export default WithRouter(TwoColumnLayout)
